import { i18n } from "@/i18n";
export default {
  path: "/release-note",
  name: "ReleaseNotes",
  component: () => import(/* webpackChunkName: "release-note" */ "@/views/ReleaseNote/ReleaseNotesView.vue"),
  meta: {
    authRequired: true,
    title: i18n.global.t("Notes de versions"),
    breadcrumb: true,
  },
};
